import { useState } from "react";
import { X } from "lucide-react";
import api from "../../services/api";

export function ClientFormModal({ client, onClose, onSave }) {
  var isEdit = !!client;
  var formState = useState({
    name: client?.name || "", email: client?.email || "", phone: client?.phone || "",
    cpf: client?.cpf || "", password: "", referral: client?.referral || "",
    account_type: client?.account_type || "pf",
  });
  var form = formState[0]; var setForm = formState[1];
  var loadingState = useState(false);
  var errorState = useState(null);

  function updateField(f, v) { setForm(function(p) { var n = {}; for (var k in p) n[k] = p[k]; n[f] = v; return n; }); }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) return;
    if (!isEdit && form.password.length < 6) { errorState[1]("Senha deve ter no minimo 6 caracteres"); return; }
    loadingState[1](true); errorState[1](null);
    try {
      var payload = { name: form.name.trim(), email: form.email.trim(), phone: form.phone.trim(), cpf: form.cpf.trim(), referral: form.referral.trim() || null, account_type: form.account_type };
      if (form.password) payload.password = form.password;
      if (isEdit) { await api.put("/clients/" + client.id, payload); }
      else { await api.post("/clients", payload); }
      onSave();
    } catch(err) {
      var detail = err.response?.data?.detail || "Erro ao salvar";
      errorState[1](typeof detail === "string" ? detail : "Erro ao salvar");
    } finally { loadingState[1](false); }
  }

  return (
    <div>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md" data-testid="client-form-modal">
        <div className="bg-white rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <h2 className="text-lg font-bold text-[#0A2F3D]">{isEdit ? "Editar Cliente" : "Novo Cliente"}</h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
          {errorState[0] && <div className="mx-5 mt-3 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{errorState[0]}</div>}
          <form onSubmit={handleSubmit} className="p-5 space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Nome Completo *</label>
              <input type="text" value={form.name} onChange={function(e) { updateField("name", e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                placeholder="Nome do cliente" required data-testid="client-form-name" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Email *</label>
                <input type="email" value={form.email} onChange={function(e) { updateField("email", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                  placeholder="email@exemplo.com" required data-testid="client-form-email" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Telefone</label>
                <input type="tel" value={form.phone} onChange={function(e) { updateField("phone", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                  placeholder="(11) 99999-9999" data-testid="client-form-phone" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">CPF</label>
                <input type="text" value={form.cpf} onChange={function(e) { updateField("cpf", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                  placeholder="000.000.000-00" data-testid="client-form-cpf" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">{isEdit ? "Nova Senha (opcional)" : "Senha *"}</label>
                <input type="password" value={form.password} onChange={function(e) { updateField("password", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                  placeholder={isEdit ? "Deixe vazio para manter" : "Minimo 6 caracteres"} minLength={isEdit ? 0 : 6}
                  required={!isEdit} data-testid="client-form-password" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Indicação</label>
                <input type="text" value={form.referral} onChange={function(e) { updateField("referral", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                  placeholder="Quem indicou?" data-testid="client-form-referral" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Tipo de Conta</label>
                <select value={form.account_type} onChange={function(e) { updateField("account_type", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6] bg-white"
                  data-testid="client-form-account-type">
                  <option value="pf">Pessoa Física (PF)</option>
                  <option value="pj">Pessoa Jurídica (PJ)</option>
                </select>
              </div>
            </div>
            <div className="flex gap-3 pt-1">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button type="submit" disabled={loadingState[0]} className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] disabled:opacity-50" data-testid="client-form-submit">
                {loadingState[0] ? "Salvando..." : isEdit ? "Salvar" : "Cadastrar"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export function DeleteClientModal({ client, onClose, onConfirm }) {
  var loadingState = useState(false);
  async function handleDelete() { loadingState[1](true); await onConfirm(client.id); loadingState[1](false); }
  return (
    <div>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-sm" data-testid="delete-client-modal">
        <div className="bg-white rounded-2xl shadow-2xl p-6">
          <h3 className="text-lg font-bold text-[#0A2F3D] mb-2">Excluir Cliente</h3>
          <p className="text-sm text-gray-500 mb-5">Tem certeza que deseja excluir <strong>{client.name}</strong>?</p>
          <div className="flex gap-3">
            <button onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
            <button onClick={handleDelete} disabled={loadingState[0]}
              className="flex-1 px-4 py-2.5 bg-red-500 text-white rounded-xl text-sm font-medium hover:bg-red-600 disabled:opacity-50"
              data-testid="delete-client-confirm">{loadingState[0] ? "Excluindo..." : "Excluir"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
